import { memo } from 'react'
import { Check, X } from 'lucide-react'
import { cn } from '../../utils'

interface PlanAttributeProps {
  text: string
  variant?: 'check' | 'loss'
}

const PlanAttribute = memo(({ text, variant = 'check' }: PlanAttributeProps) => {
  const isLoss = variant === 'loss'
  return (
    <div className="flex gap-2">
      <div
        className={cn(
          'flex size-[14px] items-center justify-center rounded-full',
          isLoss ? 'bg-red/20' : 'bg-foreground/60',
        )}
      >
        {isLoss ? (
          <X className="text-red size-[7px]" strokeWidth={3} />
        ) : (
          <Check className="text-background size-2" strokeWidth={4} />
        )}
      </div>
      <span className="text-foreground-secondary leading-2 text-[13px] font-medium">{text}</span>
    </div>
  )
})
PlanAttribute.displayName = 'PlanAttribute'

interface PlanAttributesProps {
  attributes: string[]
  variant?: 'check' | 'loss'
}

/**
 * What legacy Highlight Pro included, for the manage-subscription dialog to
 * describe a legacy subscriber's own plan. The v2 tiers state theirs through
 * `planSubscriptionFeatureList`, so nothing else should reach for this list.
 */
export const LEGACY_PRO_ATTRIBUTES = [
  'Access to premium and flagship AI models',
  'Ability to bring your own API keys',
  'Real-time cloud transcription',
  'Enhanced meeting notes',
  'Unlimited highlights',
  'Priority support',
]

export const PlanAttributes = memo(({ attributes, variant = 'check' }: PlanAttributesProps) => {
  return (
    <div className="flex flex-col gap-3.5">
      {attributes.map((text, index) => (
        <PlanAttribute key={index} text={text} variant={variant} />
      ))}
    </div>
  )
})
PlanAttributes.displayName = 'PlanAttributes'
